module.exports = __webpack_public_path__ + "static/media/pub.ac2585ca.webp";